import styles from './ConsultingSection.module.scss';
import { PageSections } from '../../../utils/constants';

const services = [
    {
        title: 'vCISO',
        description:
            'Fractional, executive-level security leadership without the full-time cost. We build and run your security program, report to leadership, and keep you audit-ready year-round.',
    },
    {
        title: 'CMMC Readiness',
        description:
            'Gap analysis, System Security Plan development, and control remediation to get your organization assessment-ready — including an optional Mock Assessment before the real evaluation.',
    },
    {
        title: 'FedRAMP Advisory',
        description:
            'Guidance built on hands-on FedRAMP authorization experience, across every phase from documentation through certification.',
    },
    {
        title: 'AI Audit & Governance',
        description:
            'Independent assessment of AI system risk, governance, and control maturity, grounded in the NIST AI Risk Management Framework.',
    },
];

const ConsultingSection = () => {
    const menuItems = [...PageSections];
    menuItems.pop();

    return (
        <div className={styles.consulting}>
            <div className={styles.container}>
                <div className={styles.info}>
                    <h2>Services</h2>

                    <p>
                        Gravity Security delivers hands-on compliance and cybersecurity advisory
                        for organizations navigating CMMC, FedRAMP, and AI governance requirements,
                        backed by 30+ years of combined practitioner experience.
                    </p>
                </div>

                <div className={styles.grid}>
                    {services.map((service) => (
                        <div className={styles.card} key={service.title}>
                            <h3>{service.title}</h3>
                            <p>{service.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ConsultingSection;